import React from 'react';
import { InfoIcon } from 'lucide-react';
interface Step1BasicsProps {
  formData: any;
  updateFormData: (data: any) => void;
}
const Step1Basics: React.FC<Step1BasicsProps> = ({
  formData,
  updateFormData
}) => {
  const coverageOptions = [{
    id: 'tuition',
    label: 'Tuition Fees'
  }, {
    id: 'stipend',
    label: 'Monthly Stipend'
  }, {
    id: 'travel',
    label: 'Travel Allowance'
  }, {
    id: 'books',
    label: 'Books & Materials'
  }, {
    id: 'housing',
    label: 'Housing'
  }, {
    id: 'other',
    label: 'Other Expenses'
  }];
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    updateFormData({
      [name]: value
    });
  };
  const handleNumberInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    // Only allow numbers
    if (value === '' || /^\d+$/.test(value)) {
      updateFormData({
        [name]: value
      });
    }
  };
  const handleCoverageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      value,
      checked
    } = e.target;
    const updatedCoverage = checked ? [...formData.coverageTypes, value] : formData.coverageTypes.filter((type: string) => type !== value);
    updateFormData({
      coverageTypes: updatedCoverage
    });
  };
  return <div data-id="element-819">
      <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-820">
        Scholarship Basics
      </h2>
      <p className="text-gray-600 mb-6" data-id="element-821">
        Provide the basic information about your partnership scholarship.
      </p>
      <div className="space-y-6" data-id="element-822">
        <div data-id="element-823">
          <label htmlFor="scholarshipTitle" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-824">
            Scholarship Title <span className="text-red-500" data-id="element-825">*</span>
          </label>
          <input type="text" id="scholarshipTitle" name="scholarshipTitle" value={formData.scholarshipTitle || ''} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="e.g., Engineering Excellence Scholarship" required data-id="element-826" />
          <p className="text-xs text-gray-500 mt-1" data-id="element-827">
            Choose a clear and descriptive name for your scholarship program
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-828">
          <div data-id="element-829">
            <label htmlFor="seatsAvailable" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-830">
              Seats Available <span className="text-red-500" data-id="element-831">*</span>
            </label>
            <input type="text" id="seatsAvailable" name="seatsAvailable" value={formData.seatsAvailable || ''} onChange={handleNumberInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="e.g., 10" required data-id="element-832" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-833">
              Number of scholarship positions available
            </p>
          </div>
          <div data-id="element-834">
            <label htmlFor="durationYears" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-835">
              Duration in Years <span className="text-red-500" data-id="element-836">*</span>
            </label>
            <input type="text" id="durationYears" name="durationYears" value={formData.durationYears || ''} onChange={handleNumberInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="e.g., 4" required data-id="element-837" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-838">
              Length of the scholarship program in years
            </p>
          </div>
        </div>
        <div data-id="element-839">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-840">
            Coverage Type <span className="text-red-500" data-id="element-841">*</span>
          </label>
          <p className="text-sm text-gray-500 mb-3" data-id="element-842">
            Select all expenses covered by this scholarship
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-843">
            {coverageOptions.map(option => <div key={option.id} className="flex items-center" data-id="element-844">
                <input type="checkbox" id={option.id} name="coverageTypes" value={option.id} checked={formData.coverageTypes?.includes(option.id)} onChange={handleCoverageChange} className="h-4 w-4 text-primary-500 focus:ring-primary-500 border-gray-300 rounded" data-id="element-845" />
                <label htmlFor={option.id} className="ml-2 text-sm text-gray-700" data-id="element-846">
                  {option.label}
                </label>
              </div>)}
          </div>
        </div>
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4" data-id="element-847">
          <div className="flex items-start" data-id="element-848">
            <InfoIcon className="w-5 h-5 text-blue-500 mr-3 mt-0.5" data-id="element-849" />
            <div data-id="element-850">
              <h3 className="text-sm font-medium text-blue-800 mb-1" data-id="element-851">
                Scholarship Approval Process
              </h3>
              <p className="text-sm text-blue-700" data-id="element-852">
                After submission, your scholarship will be reviewed by the
                Ministry of Higher Education and Scientific Research (MoHESR)
                for approval before it becomes active on the platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Step1Basics;